import Overlay from '@jo-v1/components/Overlay';
import { HiX } from 'react-icons/hi';

import { useFeatureFlags } from '@core/context/FeatureFlagsContext';
import useEmbeddedVoyagerObserver from '@core/hooks/useEmbeddedVoyagerObserver';
import cn from '@core/utils/classNames';

import styles from './SlideOut.module.css';
import type { SlideOutComponent } from './types';

const SlideOut: SlideOutComponent = ({ show, children, onClose, width }) => {
  const flags = useFeatureFlags();
  const isUGToGradResultsPageABTest = flags?.voyagerGradResultsPage === 'test';
  const { isEmbeddedVoyager } = useEmbeddedVoyagerObserver();

  if (!show) return null;

  if (show && isEmbeddedVoyager) {
    window.parent.postMessage('SlideOutShown', '*');
  }

  return (
    <Overlay clickHandler={onClose} zIndex={40}>
      <div
        className={cn(
          styles.slideOut,
          width === 'extended' && styles.extended,
          width === 'fullyExtended' && styles.fullyExtended,
          isUGToGradResultsPageABTest && styles.ugToGradTest
        )}
      >
        <button data-testid="slideout-close-btn" type="button" className={styles.closeBtn} onClick={onClose}>
          <HiX size={20} />
        </button>
        <div
          className={cn(
            styles.content,
            width === 'extended' && styles.extended,
            width === 'fullyExtended' && styles.fullyExtended
          )}
        >
          {children}
        </div>
      </div>
    </Overlay>
  );
};
SlideOut.defaultProps = {
  width: 'default',
};

export default SlideOut;
